import tw from "twin.macro"
import styled from "@emotion/styled/macro"

import { StyledButton } from "../../../Styled/Button"
import { StyledInput, StyledSelect } from "../../../Styled/Form"
import { H5, Small } from "../../../Styled/Text"

export const Form = tw.form`relative w-full md:flex md:flex-col md:items-stretch md:justify-between mb-12`
export const FormTitle = tw(H5)`font-normal text-sm md:text-lg mb-6`
export const FormStep = styled(Small)`
  ${tw`font-normal text-sm`}
`
export const FormItem = tw.div`w-full`
export const Input = tw(StyledInput)`bg-white`
export const Select = tw(StyledSelect)`bg-white`
export const Button = styled(StyledButton)`
  ${({ hidden }) => hidden && tw`opacity-0 invisible`}
`
export const WideButton = tw(StyledButton)`flex-shrink-0 w-auto rounded-l-none rounded-r-md`
export const Steps = tw.div`relative w-full z-10`
export const Step = styled.div`
  ${tw`flex items-stretch justify-between transform transition-all duration-200 last:absolute last:inset-0`}
  ${({ active }) =>
    active
      ? tw`opacity-100 visible translate-x-0 pointer-events-auto`
      : tw`opacity-0 invisible pointer-events-none -translate-x-16 last:translate-x-16`}
  input, select {
    ${tw`rounded-r-none border-r-0`}
  }
`
